import { decodeClipboardPayload } from '../../core/state/clipboard-payload.js';

/** What a paste event offers, read synchronously by the handler (clipboard data dies with the event). */
export interface PasteOffer {
  readonly text: string;
  readonly hasImageFile: boolean;
  readonly hasChoiceHandler: boolean;
}

/**
 * The way a paste onto the board takes:
 * - `board-payload`: the board's own marker — insert the objects (size, rotation kept);
 * - `ask`: foreign image AND text (PowerPoint, Word) — the host asks "image or text?";
 * - `image`: place the picture; `text`: a new textbox; `mirror`: the board-internal copy.
 */
export type PasteRoute = 'board-payload' | 'ask' | 'image' | 'text' | 'mirror';

/**
 * Chooses the paste route. The board's own marker is checked FIRST (Stefan, 2026-10-28): since
 * a copied image also carries image/png, checking the picture first would ask on every
 * board-to-board paste, or re-upload the picture and drop its rotation (measured before the
 * change). A damaged marker decodes to nothing and is treated like foreign text.
 */
export function decidePasteRoute(offer: PasteOffer): PasteRoute {
  if (decodeClipboardPayload(offer.text) !== null) return 'board-payload';
  const hasText = offer.text.trim() !== '';
  if (offer.hasImageFile) return offer.hasChoiceHandler && hasText ? 'ask' : 'image';
  return hasText ? 'text' : 'mirror';
}
